<asax-header-search-input-info [searchInput]="searchInput">
  <content *ngTemplateOutlet="content"></content>
</asax-header-search-input-info>

<ng-template #content>
  <div class="text-nowrap">
    <label id="{{'header-filter-label-' + searchInput.id}}"
           for="{{'header-filter-' + searchInput.id}}"
           class="form-label mb-0 me-1">
      {{searchInput.label}}
    </label>
    <i *ngIf="searchInput.isDisabled"
       class="fa-light fa-eye-slash me-1"
       placement="right"
       ngbTooltip="Filter is disabled">
    </i>
  </div>
  <div ngbDropdown
       [autoClose]="'outside'"
       display="dynamic"
       placement="bottom-end">
    <div class="input-group input-group-sm has-validation">
      <button ngbDropdownToggle
              id="{{'header-filter-' + searchInput.id}}"
              type="button"
              class="form-control"
              [class.is-valid]="searchInput?.value?.length > 0"
              [class.border-radius-right-0]="searchInput?.value?.length > 0">
        {{valueToDisplay}}
      </button>
      <button *ngIf="searchInput?.value?.length > 0"
              class="btn btn-light border-dark"
              type="button"
              (click)="clearSearchInputValue()">
        <i class="fa-light fa-xmark"></i>
      </button>
    </div>
    <div ngbDropdownMenu class="overflow-auto" style="max-height: 40vh">
      <form class="px-2 py-0">
        <div class="form-check form-switch">
          <input class="form-check-input"
                 type="checkbox"
                 [checked]="isBestMatchSelected"
                 (click)="toggleBestMatch()"
                 id="{{'best-match-' + searchInput.id}}">
          <label class="form-check-label text-primary"
                 for="{{'best-match-' + searchInput.id}}"
                 style="cursor: pointer">
            Best match
          </label>
        </div>
      </form>
      <div class="dropdown-divider"></div>
      <form class="px-2 py-0">
        <div class="input-group input-group-sm">
          <input class="form-control"
                 placeholder="Enter sky object"
                 [(ngModel)]="skyObjectsFilterValue"
                 [ngModelOptions]="{standalone: true}">
          <button *ngIf="skyObjectsFilterValue"
                  class="btn btn-light border-dark"
                  type="button"
                  (click)="clearSkyObjectsFilterValue()">
            <i class="fa-light fa-xmark"></i>
          </button>
        </div>
      </form>
      <div class="dropdown-divider"></div>
      <ng-container *ngFor="let skyObject of skyObjectsDropdownItems">
        <ng-container *ngIf="shouldSkyObjectBeDisplayed(skyObject)">
          <button ngbDropdownItem 
              (click)="onSkyObjectClick(skyObject)"
              [class.active]="skyObject.selected"
              style="padding-left: 10px !important;"
            >
            <div class="options-container">
              <div class="ms-1 me-1" style="width: 40px;">
              <ng-container *ngIf="skyObject.resolverType === 'SIMBAD'">
                <img
                  id="Simbad_logo_file"
                  class="py-1 ms-1"
                  style="width: 90%;"
                  src="assets/images/simbad.png"
                  alt="Simbad log"
                >
              </ng-container>
              <ng-container *ngIf="skyObject.resolverType === 'NED'">
                <img 
                  id="Ned_logo_file"
                  class="py-1 ms-1"
                  style="width: 90%;"
                  src="assets/images/ned.png"
                  alt="Ned logo"
                >
              </ng-container>
              </div>
              <span class="ms-1" [innerHTML]="skyObject.text"></span>
            </div>
          </button>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <div *ngIf="isBestMatchSelected"
       class="form-text">
    best match only
  </div>
</ng-template>
